export function timeline({ start, end, marker = 0, beforeCalc, afterCalc }) {
	
	const tl = { start: 0, end: 0, length: 0, marker: 0 }
	const pos = { scroll: 0, pixels: 0, percent: 0, percentRaw: 0 }
	
	function calculate() {
		beforeCalc && beforeCalc()
		tl.start = start()
		tl.end = end()
		tl.length = tl.end - tl.start
		tl.marker = minmax(0, window.innerHeight, window.innerHeight * marker)
		afterCalc && afterCalc()
	}

	function position() {
		pos.scroll = window.scrollY + tl.marker
		pos.pixels = minmax(0, tl.end - tl.start, pos.scroll - tl.start)
		const percent = inverseLerp(tl.start, tl.end, pos.scroll)
		pos.percent = minmax(0, 1, percent)
		pos.percentRaw = percent
		return pos
	}

	const callbacks = []
	function addCallback(fn) {
		callbacks.push(fn)
	}

	function runCallbacks() {
		// const last = pos.percent
		const next = position()
		// if (last === next.percent) return
		callbacks.map(fn => fn(next, tl))
	}

	function calcAndRunCallbacks() {
		calculate()
		runCallbacks()
	}

	let animId
	function onScroll(event) {
		if (animId) return
		animId = window.requestAnimationFrame(() => {
			window.cancelAnimationFrame(animId)
			animId = false
			runCallbacks()
		})
	}

	let resizeId
	function onResize(event) {
		clearTimeout(resizeId);
		resizeId = setTimeout(calcAndRunCallbacks, 100);
	}

	function setupEvents() {
		window.addEventListener('DOMContentLoaded', calcAndRunCallbacks)
		window.addEventListener('resize', onResize)
		window.addEventListener('scroll', onScroll)
	}

	function removeEvents() {
		window.removeEventListener('DOMContentLoaded', calcAndRunCallbacks)
		window.removeEventListener('resize', onResize)
		window.removeEventListener('scroll', onScroll)
	}

	// init
	setupEvents()
	calcAndRunCallbacks()
	
	return {
		onUpdate: addCallback,
		update: calcAndRunCallbacks,
		end: removeEvents
	}
}


// helper for getting the document position of an element
// edge: top | bottom
// viewportPercent: vertical position in the viewport (0 = top, 1 = bottom)

export function viewportPosition(el, { edge = 'top', viewportPercent = 1 }) {
	const rect = el.getBoundingClientRect()
	if (edge === 'top') {
		return window.scrollY + rect.top - (window.innerHeight * viewportPercent)
	}
	if (edge === 'bottom') {
		return window.scrollY + rect.top + rect.height - (window.innerHeight * viewportPercent)
	}
}

function minmax(min, max, value) {
	return Math.max(min, Math.min(value, max))
}

function inverseLerp(a, b, v) {
	return (v - a) / (b - a) || 0
}